export default "__VITE_ASSET__B8kkLS4S__"